module.exports = __webpack_public_path__ + "img/music.e59ab7c4.png";